import React from 'react';

const PropertyCharacteristics = ({ propertyData }) => {
  if (!propertyData || propertyData.status !== 'success' || !propertyData.data) {
    return null;
  }

  const data = propertyData.data;

  const characteristics = [
    {
      icon: (
        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      label: 'Type',
      value: data.homeType?.replace('_', ' ').toLowerCase() || 'N/A',
      bgColor: 'bg-blue-100'
    },
    {
      icon: (
        <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      label: 'Built',
      value: data.yearBuilt || 'N/A',
      bgColor: 'bg-green-100'
    },
    {
      icon: (
        <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
        </svg>
      ),
      label: 'Beds',
      value: data.bedrooms || 'N/A',
      bgColor: 'bg-red-100'
    },
    {
      icon: (
        <svg className="w-4 h-4 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10v11M20 10v11" />
        </svg>
      ),
      label: 'Baths',
      value: data.bathrooms || 'N/A',
      bgColor: 'bg-yellow-100'
    },
    {
      icon: (
        <svg className="w-4 h-4 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
        </svg>
      ),
      label: 'Living Area',
      value: data.livingArea ? `${data.livingArea.toLocaleString()} sqft` : 'N/A',
      bgColor: 'bg-indigo-100'
    },
    {
      icon: (
        <svg className="w-4 h-4 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
        </svg>
      ),
      label: 'Lot Size',
      value: data.lotSize ? `${data.lotSize.toLocaleString()} sqft` : 'N/A',
      bgColor: 'bg-orange-100'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow mb-6">
      <div className="p-5">
        <div className="flex items-center mb-4">
          <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
            <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
            </svg>
          </div>
          <h4 className="text-lg font-semibold text-gray-900">Property Characteristics</h4>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {characteristics.map((char, index) => (
            <div key={index} className="text-center p-3 bg-gray-50 rounded-lg">
              <div className={`w-8 h-8 ${char.bgColor} rounded-full flex items-center justify-center mx-auto mb-2`}>
                {char.icon}
              </div>
              <div className="text-xs font-medium text-gray-600 mb-1">{char.label}</div>
              <div className="text-sm font-semibold text-gray-900">{char.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PropertyCharacteristics;